/**
 * useFederatedStatus — reagiert live auf federation-status-change-Events aus
 * modules/registry.ts. Sidebar/MobileHomeTabBar zeigen darauf gruen/rot-Punkte.
 *
 * Rueckgabe:
 *  - 'up' → Federation-Modul geladen (registerModule() lief) oder statisches Portal-Bundle-Modul
 *  - 'down' → HEAD-Check gescheitert oder import() failed
 *  - 'unknown' → noch nicht probiert (Portal boot-Phase VOR initModules)
 *
 * Bei slug=null|undefined liefert der Hook 'unknown' — Consumer soll dann
 * keinen Punkt rendern (Nav-Item ohne Federation-Bezug).
 *
 * Regel: [[feedback_federation_no_static_imports]].
 */
import { useEffect, useState } from 'react';
import { getModuleStatus, type ModuleStatus } from '../modules/registry';

export function useFederatedStatus(slug: string | null | undefined): ModuleStatus {
  const [status, setStatus] = useState<ModuleStatus>(() =>
    slug ? getModuleStatus(slug) : 'unknown'
  );

  useEffect(() => {
    if (!slug) {
      setStatus('unknown');
      return;
    }
    // Initial-Sync (falls Status sich seit useState-Init geaendert hat)
    setStatus(getModuleStatus(slug));

    const onChange = (e: Event) => {
      const detail = (e as CustomEvent<{ slug: string; status: ModuleStatus }>).detail;
      if (detail?.slug === slug) setStatus(detail.status);
    };
    window.addEventListener('federation-status-change', onChange);
    return () => window.removeEventListener('federation-status-change', onChange);
  }, [slug]);

  return status;
}
